<template>
  <div>
    <h1>
      HashTag
    </h1>
    {{ hash }}
  </div>
</template>

<script>
export default {
  props: {
    hash: {}
  }
}
</script>

<style>

</style>
